import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

export const validationsService = {
    runPipelinesForClaim
}

function runPipelinesForClaim(payload) {
    return axios.post(API_BASE_URL + '/api/admin/v1/validations/runforclaim', payload)
}
